function toggleAppBasedOnOS() {
  if (document.querySelector('#shopify-section-sale-password-page')) {
    const userSystem = navigator.userAgent;
    const index = userSystem.indexOf("Mac");
    if (index !== -1) {
      document.querySelector(".windows-app").style.display = 'none';
      document.querySelector(".mac-app").style.display = 'block';
    } else {
      document.querySelector(".windows-app").style.display = 'block';
      document.querySelector(".mac-app").style.display = 'none';
    }
  }
}
function goToPreviousPage() {
  if (document.querySelector('#shopify-section-sale-password-page')) {
    if (document.cookie.split('; ').find(row => row.startsWith(accessLabel))) {
      setTimeout(function() {
        if (document.referrer.includes('/pages/password')) {
          window.location.href = '/';
        } else {
          window.location.href = document.referrer
        }
      }, 100);
    }
  }
}
goToPreviousPage();
toggleAppBasedOnOS();

function setSaleWithExpiry(name, value, expirationInDays) {
  if (document.querySelector('#shopify-section-sale-password-page')) {
    const now = new Date();
    const expiryDate = new Date(now);
    expiryDate.setDate(now.getDate() + expirationInDays);

    const expiresUTC = expiryDate.toUTCString();
    const formattedDate = `${expiryDate.getDate()} ${expiryDate.toLocaleString('default', { month: 'long' })}`;

    // Set the cookie
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expiresUTC}; path=/`;
    goToPreviousPage();
  }
}




let intervalId;
if (passremoved) {
    // Start the countdown immediately
    intervalId = setInterval(updateCountdownTimer, 1000);
}
// Function to update the countdown timer
function updateCountdownTimer() {
    // Get current time in UTC (GMT)
    const currentTimeUTC = new Date().toISOString();  // Get current time in UTC format
    const timeLeft = (new Date(passremoved) - new Date(currentTimeUTC)) / 1000;  // Time difference in seconds

    if (timeLeft > 0) {
        updateCountdownDisplay(timeLeft);
    } else {
        updateCountdownDisplay(0);
        clearInterval(intervalId);
        setSaleWithExpiry(accessLabel, 'true', expirationInDays);
    }
}

// Function to display the countdown
function updateCountdownDisplay(seconds) {
    const d = Math.floor(seconds / (24 * 60 * 60)),  // Calculate days
          h = Math.floor((seconds % (24 * 60 * 60)) / 3600),  // Calculate hours
          m = Math.floor((seconds % 3600) / 60),  // Calculate minutes
          s = Math.floor(seconds % 60);  // Calculate seconds

    // Update the countdown timer in the DOM
    document.querySelector('.count_down_timer').innerHTML = `
        ${d > 0 ? `<div class="timer-section"><span>${d}</span> Days</div><span class="timer-dot">:</span>` : ''}
        <div class="timer-section"><span>${h}</span> Hours</div><span class="timer-dot">:</span>
        <div class="timer-section"><span>${m}</span> Minutes</div><span class="timer-dot">:</span>
        <div class="timer-section"><span>${s}</span> Seconds</div>
    `;
}

if (document.querySelector('.sale-password-page')) {
  document.getElementById('passwordForm').addEventListener('submit', function(e) {
    e.preventDefault();  // Prevent default form submission

    var enteredPassword = document.getElementById('passwordInput').value.toLowerCase();
    var correctPassword = atob(encodedString).toLowerCase();

    if (enteredPassword == correctPassword) {
      setSaleWithExpiry(accessLabel, 'true', expirationInDays);
    } else {
      document.getElementById('error').style.display = 'block';  // Show error message if password is incorrect
    }
  });
}